import {removeRefreshToken, removeToken, setRefreshToken, setToken} from '@/util/auth'
import {Message} from 'element-ui'
import {clearStore, getStore, setStore} from '@/util/store'
import {validatenull} from '@/util/validate'
// import {deepClone} from '@/util/util'
// import website from '@/config/website'
import {
    getUserInfo,
    LoginByEmail,
    LoginByPhone,
    loginBySocial,
    loginBySso,
    loginByUsername,
    logout,
    refreshToken
} from '@/api/user'
import md5 from 'js-md5'

const user = {
    state: {
        tenantId: getStore({name: 'tenantId'}) || '',
        userInfo: getStore({name: 'userInfo'}) || [],
        permission: getStore({name: 'permission'}) || {},
        roles: [],
        menuId: {},
        menu: getStore({name: 'menu'}) || [],
        menuAll: getStore({name: 'menuAll'}) || [],
        token: getStore({name: 'token'}) || '',
        refreshToken: getStore({name: 'refreshToken'}) || '',
    },
    actions: {
        //根据用户名登录
        LoginByUsername({commit}, userInfo) {
            return new Promise((resolve, reject) => {
                loginByUsername(userInfo.tenantId, userInfo.deptId, userInfo.roleId, userInfo.username, md5(userInfo.password), userInfo.type, userInfo.key, userInfo.code, userInfo.loginType).then(res => {
                    const data = res.data;
                    if (data.error_description) {
                        Message({
                            message: data.error_description,
                            type: 'error'
                        })
                    } else {
                        if (data.role_name.indexOf('bid') != -1) {
                            commit('SET_TOKEN', data.access_token);
                            commit('SET_REFRESH_TOKEN', data.refresh_token);
                            commit('SET_TENANT_ID', data.tenant_id);
                            commit('SET_USER_INFO', data);
                            commit('DEL_ALL_TAG');
                            commit('CLEAR_LOCK');
                        }
                    }
                    resolve();
                }).catch(error => {
                    reject(error);
                })
            })
        },
        //根据手机号登录
        LoginByPhone({commit}, userInfo) {
            return new Promise((resolve, reject) => {
                LoginByPhone(userInfo.tenantId, userInfo.deptId, userInfo.roleId, userInfo.phone, userInfo.key, userInfo.code, userInfo.loginType).then(res => {
                    const data = res.data;
                    if (data.error_description) {
                        Message({
                            message: data.error_description,
                            type: 'error'
                        })
                    } else {
                        if (data.role_name.indexOf('bid') != -1) {
                            commit('SET_TOKEN', data.access_token);
                            commit('SET_REFRESH_TOKEN', data.refresh_token);
                            commit('SET_TENANT_ID', data.tenant_id);
                            commit('SET_USER_INFO', data);
                            commit('DEL_ALL_TAG');
                            commit('CLEAR_LOCK');
                        }
                    }
                    resolve();
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 根据邮箱登录
        LoginByEmail({commit}, userInfo) {
            return new Promise((resolve, reject) => {
                LoginByEmail(userInfo.tenantId, userInfo.deptId, userInfo.roleId, userInfo.email, userInfo.key, userInfo.code).then(res => {
                    const data = res.data;
                    if (data.error_description) {
                        Message({
                            message: data.error_description,
                            type: 'error'
                        })
                    } else {
                        commit('SET_TOKEN', data.access_token);
                        commit('SET_REFRESH_TOKEN', data.refresh_token);
                        commit('SET_TENANT_ID', data.tenant_id);
                        commit('SET_USER_INFO', data);
                        commit('DEL_ALL_TAG');
                        commit('CLEAR_LOCK');
                    }
                    resolve();
                }).catch(error => {
                    reject(error);
                })
            })
        },
        //根据第三方信息登录
        LoginBySocial({commit}, userInfo) {
            return new Promise((resolve) => {
                loginBySocial(userInfo.tenantId, userInfo.source, userInfo.code, userInfo.state).then(res => {
                    const data = res.data;
                    if (data.error_description) {
                        Message({
                            message: data.error_description,
                            type: 'error'
                        })
                    } else {
                        commit('SET_TOKEN', data.access_token);
                        commit('SET_REFRESH_TOKEN', data.refresh_token);
                        commit('SET_USER_INFO', data);
                        commit('SET_TENANT_ID', data.tenant_id);
                        commit('DEL_ALL_TAG');
                        commit('CLEAR_LOCK');
                    }
                    resolve();
                })
            })
        },
        //根据单点信息登录
        LoginBySso({commit}, userInfo) {
            return new Promise((resolve) => {
                loginBySso(userInfo.state, userInfo.code).then(res => {
                    const data = res.data;
                    if (data.error_description) {
                        Message({
                            message: data.error_description,
                            type: 'error'
                        })
                    } else {
                        commit('SET_TOKEN', data.access_token);
                        commit('SET_REFRESH_TOKEN', data.refresh_token);
                        commit('SET_USER_INFO', data);
                        commit('SET_TENANT_ID', data.tenant_id);
                        commit('DEL_ALL_TAG');
                        commit('CLEAR_LOCK');
                    }
                    resolve();
                })
            })
        },
        //获取用户信息
        GetUserInfo({commit}) {
            return new Promise((resolve, reject) => {
                getUserInfo().then((res) => {
                    const data = res.data.data;
                    commit('SET_ROLES', data.roles);
                    resolve(data);
                }).catch(err => {
                    reject(err);
                })
            })
        },
        //刷新token
        refreshToken({state, commit}, userInfo) {
            window.console.log('handle refresh token');
            return new Promise((resolve, reject) => {
                refreshToken(state.refreshToken, state.tenantId,
                    !validatenull(userInfo) ? userInfo.deptId : state.userInfo.dept_id,
                    !validatenull(userInfo) ? userInfo.roleId : state.userInfo.role_id
                ).then(res => {
                    const data = res.data;
                    commit('SET_TOKEN', data.access_token);
                    commit('SET_REFRESH_TOKEN', data.refresh_token);
                    commit('SET_USER_INFO', data);
                    resolve();
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 登出
        LogOut({commit}) {
            return new Promise((resolve, reject) => {
                logout().then(() => {
                    commit('SET_TOKEN', '');
                    commit('SET_ROLES', []);
                    commit('SET_TAG_LIST', []);
                    commit('DEL_ALL_TAG');
                    commit('CLEAR_LOCK');
                    commit('SET_USER_INFO', []);
                    clearStore();
                    removeToken();
                    removeRefreshToken();
                    resolve();
                }).catch(error => {
                    reject(error)
                })
            })
        },
        //注销session
        FedLogOut({commit}) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '');
                commit('SET_ROLES', []);
                commit('SET_TAG_LIST', []);
                commit('DEL_ALL_TAG');
                commit('CLEAR_LOCK');
                commit('SET_USER_INFO', []);
                clearStore();
                removeToken();
                removeRefreshToken();
                resolve();
            })
        },
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            setToken(token);
            state.token = token;
            setStore({name: 'token', content: state.token})
        },
        SET_REFRESH_TOKEN: (state, refreshToken) => {
            setRefreshToken(refreshToken)
            state.refreshToken = refreshToken;
            setStore({name: 'refreshToken', content: state.refreshToken})
        },
        SET_TENANT_ID: (state, tenantId) => {
            state.tenantId = tenantId;
            setStore({name: 'tenantId', content: state.tenantId})
        },
        SET_USER_INFO: (state, userInfo) => {
            if (validatenull(userInfo.avatar)) {
                userInfo.avatar = "/img/bg/img-logo.png";
            }
            state.userInfo = userInfo;
            setStore({name: 'userInfo', content: state.userInfo})
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles;
        },
    }

}
export default user
